import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { MainListItems_Clinics } from './clinicNavBar';

export const DRAWER_WIDTH_XL = 195;
export const DRAWER_WIDTH_LG = 183;
export const DRAWER_WIDTH_MD = 172;
export const DRAWER_WIDTH_SM = 162;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: DRAWER_WIDTH_LG,
    [theme.breakpoints.up('xl')]: {
      width: DRAWER_WIDTH_XL,
    },
    [theme.breakpoints.down('md')]: {
      width: DRAWER_WIDTH_MD,
    },
    [theme.breakpoints.down('sm')]: {
      width: DRAWER_WIDTH_SM,
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(5),
    },
    [theme.breakpoints.up('xl')]: {
      width: theme.spacing(7),
    },
  },
}));

export default function SharedAdminDrawer({ open, onOpen, onClose, appBarVisible = true, onVideocallClick, onNotificationsClick, onMessagesClick }) {
  const classes = useStyles();
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <Grid style={{ height: appBarVisible ? (isXl ? 69 : 'clamp(56.5px, 3.95vw, 66px)') : 0, backgroundColor: '#002D55', overflow: 'hidden' }} />
      <Divider />
      <List style={{ marginLeft: isXl ? -5 : -8 }}>
        <ListItem style={{ minHeight: 56, margin: 0, paddingLeft: isXl ? 3 : 3, justifyContent: 'flex-start' }}>
          <IconButton onClick={open ? onClose : onOpen}>
            <MenuIcon style={{ fontSize: 'clamp(21px, 1.46vw, 28px)', color: '#002D55' }} />
          </IconButton>
        </ListItem>
        <MainListItems_Clinics open={open} onVideocallClick={onVideocallClick} onNotificationsClick={onNotificationsClick} onMessagesClick={onMessagesClick} />
      </List>
      <Divider />
    </Drawer>
  );
}
